var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowSmallBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8439 18.0165C28.4199 8.98605 16.9838 3.23378 13.5111 1.72612C10.0383 0.218463 7.47409 0.923231 3.94399 4.96734C0.413897 9.01145 0.910348 15.9971 0.859012 18.9416C0.807675 21.8861 6.87402 29.3045 18.8439 18.0165Z",
    fill: "#94DEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowSmallBg);
export default __webpack_public_path__ + "static/media/how-small-bg.d8387857.svg";
export { ForwardRef as ReactComponent };